<template>
    <div class="main">
        <c-panel>
            <info></info>
        </c-panel>
    </div>
</template>
<script>
import info from "./info"

export default {
    components: { info }
}
</script>
